import { Typography, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

export const HeaderText = styled(Typography)(() => ({
  color: ediphiPalette.black950,
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "22px",
}));
